var _stop, _stop2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
var SvgClose = function SvgClose(props) {
  var _id2 = useUniqueInlineId();
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "75.329%",
    y1: "15.413%",
    x2: "0%",
    y2: "100%",
    id: _id
  }, _stop || (_stop = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C66FF",
    offset: "0%"
  })), _stop2 || (_stop2 = /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37F",
    offset: "100%"
  }))), /*#__PURE__*/React.createElement("path", {
    id: _id2,
    d: "M0 0h20v20H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "close_svg__prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#".concat(_id2)
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#close_svg__prefix__b)",
    fill: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.48 4.52a.75.75 0 01.067.984l-.067.077L11.06 10l4.42 4.42a.75.75 0 01-.984 1.127l-.077-.067L10 11.06l-4.42 4.42a.75.75 0 01-1.127-.984l.067-.077L8.94 10 4.52 5.58a.75.75 0 01.984-1.127l.077.067L10 8.94l4.42-4.42a.75.75 0 011.06 0z"
  })))));
};
export default SvgClose;